import { render, staticRenderFns } from "./AdminSubjectsStudentBatch.vue?vue&type=template&id=a683f780&scoped=true"
import script from "./AdminSubjectsStudentBatch.vue?vue&type=script&lang=js"
export * from "./AdminSubjectsStudentBatch.vue?vue&type=script&lang=js"
import style0 from "./AdminSubjectsStudentBatch.vue?vue&type=style&index=0&id=a683f780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a683f780",
  null
  
)

export default component.exports